import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

const CALCULATOR_STATISTICS_FIELDS = `#graphql
  foreignExchangeRates { from to rate }
  holdings {
    financialProduct {
      id: stringId
      isCash
      translatedName { ${TRANSLATED_STRING_FIELDS} }
    }
    totalCents
  }
`;

export const FETCH_CALCULATOR_ACCOUNT = ({
  canReadAccountNumber,
}: {
  canReadAccountNumber: boolean;
}) => gql`
  query fetchCalculatorAccount($accountId: SafeString!) {
    fetchAccount(input: { accountId: $accountId }) {
      account {
        id: stringId
        type
        ${canReadAccountNumber ? 'custodianAccountNumber' : ''}
        statistics {
          ${CALCULATOR_STATISTICS_FIELDS}
        }
      }
    }
  }
`;

export const TRIGGER_CALCULATOR_INTEGRATION = gql`
  mutation triggerCalculatorIntegration(
    $input: TriggerSynchronousIntegrationInput!
  ) {
    triggerSynchronousIntegration(input: $input) {
      workflowCompletion {
        id
        context
      }
    }
  }
`;
